// extracted by mini-css-extract-plugin
export default {"popover":"popover--7e16a718"};